import { PureComponent } from 'react'
import Button from '@mui/material/Button'
import qs from 'qs'
import { GoogleLogin } from '@react-oauth/google'
import { FacebookLogin } from 'react-facebook-login-component'
import TextField from '@mui/material/TextField'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import Divider from '@mui/material/Divider'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import EmailIcon from '@mui/icons-material/EmailOutlined'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import axios from 'axios'
import EmailValidator from 'email-validator'
import { KEY_FORGOT_PASSWORD, KEY_LOGIN, KEY_CALENDAR, KEY_TERMS_AND_CONDITIONS, KEY_PRIVACY_POLICY, KEY_SIGNUP_URL} from "../../shared/cb-constant"
import { withCookies } from 'react-cookie'
import './Login.css'
import logo from '../../asset/CB_logo_horizontal.png'

class App extends PureComponent {
  
  constructor(props) {
    super(props)
    this.state = {
      errorMessage: "", 
      successMessage: "",
      showPassword: false,
      passwordDialogOpen: false,
      passwordError: false,
      passwordErrorMessage: "",
      loginEmailError: false,
      loginEmailErrorMessage: "",
      loginPasswordError: false,
      loginPasswordErrorMessage: "", 
      email: this.props.cookies.get("CBrememberMe") ? this.props.cookies.get("CBrememberMe") : "",
      rememberMe: this.props.cookies.get("CBrememberMe") ? true : false,
      password: ""
    }
    //bind 'this' context into these functions
    this.handleInputChange = this.handleInputChange.bind(this)
    this.submit = this.submit.bind(this)
    this.googleSuccess = this.googleSuccess.bind(this)
    this.googleError = this.googleError.bind(this)
    this.responseFacebook = this.responseFacebook.bind(this)
  }

  googleSuccess(response) {
    axios.post(KEY_LOGIN, qs.stringify({
      idtoken: response.credential,
      method: 'google'
    })).then(res => {
      if (res.data.success) {
        localStorage.setItem("accessToken", res.data.accessToken)
        window.location.assign(res.data.action)
      } else {
        this.setState({errorMessage: res.data.error})
      }
    }).catch(err => {
      this.setState({errorMessage: err.message})
    })
  }

  googleError(response) {
    this.setState({errorMessage: response.details})
  }

  responseFacebook = response => {
    axios.post(KEY_LOGIN, qs.stringify({
      idtoken: response.accessToken,
      method: 'facebook'
    })).then(res => {
      if (res.data.success) {
        localStorage.setItem("accessToken", res.data.accessToken)
        window.location.assign(res.data.action)
      } else {
        this.setState({errorMessage: res.data.error})
      }
    }).catch(err => {
      this.setState({errorMessage: err.message})
    })
  }

  handleInputChange = name => event => {
    this.setState({[name]: event.target.value})
  }

  handleCheckboxChange = name => event => {
    this.setState({[name]: event.target.checked})
  }

  pressEnter = (event, a, b) => {
    if (event.key==='Enter' && (this.state.email && this.state.password)) {
      this.submit()
    }
  }

  handleClickShowPassword = () => {
      this.setState({showPassword: !this.state.showPassword})
  }

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  submit() {
    this.setState({errorMessage:""})
    if (EmailValidator.validate(this.state.email)) {
      this.setState({loginEmailErrorMessage: "", loginEmailError: false})
      if (this.state.password == "") {
        this.setState({loginPasswordErrorMessage: "Enter Password", loginPasswordError: true})
      } else {
        axios.post(KEY_LOGIN, qs.stringify({
          email: this.state.email,
          password: encodeURIComponent(this.state.password),
          method: "email"
        })).then(res => {
          if (res.data.success) {
            this.setState({errorMessage: "", successMessage: "Success... Logging in", loginEmailErrorMessage: "", loginEmailError: false})
            if (this.state.rememberMe === true) {
              this.props.cookies.set("CBrememberMe", this.state.email, {maxAge: 365})
            } else {
              this.props.cookies.remove("CBrememberMe")
            }
            localStorage.setItem("accessToken", res.data.accessToken)
            window.location.assign(KEY_CALENDAR)
          } else {
            this.setState({errorMessage: res.data.error, loginEmailErrorMessage: "", loginEmailError: false})
          }
        }).catch(err => {
          this.setState({errorMessage: err.message})
        })
      }
    } else {
      this.setState({loginEmailErrorMessage: "Enter Valid Email", loginEmailError: true})
      if (this.state.password == "") {
        this.setState({loginPasswordErrorMessage: "Enter Password", loginPasswordError: true})
      } else {
        this.setState({loginPasswordErrorMessage: "", loginPasswordError: false})
      }
    }
  }

  openPasswordReminder = () => {
    this.setState({ passwordDialogOpen: true });
  }

  closePasswordReminder = () => {
    this.setState({ passwordDialogOpen: false });
  }

  forgotPassword() {
    if (EmailValidator.validate(this.state.passwordEmail)) {
      axios.post(KEY_FORGOT_PASSWORD, qs.stringify({
        email: this.state.passwordEmail.trim(),
      })).then(res => {
        if (res.data.error) {
          this.setState({passwordEmailErrorMessage: res.data.error, passwordErrorMessage: "", passwordError: false})
        } else {
          this.setState({errorMessage: "Email has been sent. Please check your email, including spam folders.", passwordErrorMessage: "", passwordError: false})
          this.closePasswordReminder()
        }
      }).catch(err => {
        this.setState({errorMessage: err.message, passwordErrorMessage: "", passwordError: false})
        this.closePasswordReminder()
      })
    } else {
      this.setState({passwordErrorMessage: "Enter Valid Email", passwordError: true})
    }
  }

  render() {
    return (
      <div className="app"> 
        <div className="header">
          <a title="Back to your Budget" href="/">
            <img alt="CalendarBudget" src={logo}/>
          </a>
        </div>
        <div className="mainArea">
          <div className="loginBox"> 
            <h1 className="loginTitle">Log In</h1>
            <div className="signUpLink">New to CalendarBudget? <a href={KEY_SIGNUP_URL}>Sign up today.</a></div>
            <div id="loginError">{this.state.errorMessage}</div>
            <div id="loginSuccess">{this.state.successMessage}</div>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <EmailIcon sx={{ color: 'action.active', mr: 1, my: 1.9, fontSize: 20 }} />
              <TextField
                onChange={this.handleInputChange('email')}
                onKeyPress={this.pressEnter}
                autoComplete="email"
                inputProps={{required:true}}
                fullWidth
                value={this.state.email}
                error={this.state.loginEmailError}
                helperText={this.state.loginEmailErrorMessage}
                margin='normal'
                variant='standard'
                id='email'
                label='Email'/>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <LockOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 1.9, fontSize: 20 }} />
              <TextField
                onChange={this.handleInputChange('password')}
                onKeyPress={this.pressEnter}
                autoComplete="password"
                inputProps={{required:true}}
                fullWidth
                autoFocus={this.state.rememberMe}
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.password}
                error={this.state.loginPasswordError}
                helperText={this.state.loginPasswordErrorMessage}
                margin='normal'
                variant='standard'
                id='password'
                label='Password'
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                        edge="end">
                        {this.state.showPassword ? <VisibilityOff sx={{  ml:0.6, mr: 0.6, my: 0.6, fontSize: 20 }} /> : <Visibility  sx={{  ml: 0.6, mr: 0.6, my: 0.6, fontSize: 20 }}/>}
                      </IconButton>
                    </InputAdornment>
                  
                }}/>
            </Box>
            <br />
    
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.rememberMe}
                  onChange={this.handleCheckboxChange('rememberMe')}
                  value="rememberMe"
                  color="primary"
                />
              }
              label="REMEMBER ME"
              labelPlacement="start"
              classes={{root: "rememberMe"}}/>
            
            <Button 
              color="primary"
              className="forgot"
              onClick={this.openPasswordReminder}>
              FORGOT PASSWORD
            </Button>

            <Button 
              variant="contained"
              color="primary"
              onClick={this.submit}
              style={{width: "100%", marginTop: "10px"}}>
              LOG IN
            </Button>
            <div style={{clear: "both", padding: "20px 0 0"}}></div>
            <Divider sx={{color: "grey"}}>or</Divider>
            <div style={{clear: "both", padding: "10px 0 0"}}></div>
    
            <FacebookLogin socialId="247668755296478"
              language="en_US"
              scope="email"
              responseHandler={this.responseFacebook}
              xfbml={true}
              fields="id,email,name"
              version="v19.0"
              className="socialLoginButton facebook">
                <div>
                  <img alt="Facebook Logo" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNjdweCIgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDY3IDY3OyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNjcgNjciIHdpZHRoPSI2N3B4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNMjkuNzY1LDUwLjMyaDYuNzQ0VjMzLjk5OGg0LjQ5OWwwLjU5Ni01LjYyNGgtNS4wOTUgIGwwLjAwNy0yLjgxNmMwLTEuNDY2LDAuMTQtMi4yNTMsMi4yNDQtMi4yNTNoMi44MTJWMTcuNjhoLTQuNWMtNS40MDUsMC03LjMwNywyLjcyOS03LjMwNyw3LjMxN3YzLjM3N2gtMy4zNjl2NS42MjVoMy4zNjlWNTAuMzJ6ICAgTTM0LDY0QzE3LjQzMiw2NCw0LDUwLjU2OCw0LDM0QzQsMTcuNDMxLDE3LjQzMiw0LDM0LDRzMzAsMTMuNDMxLDMwLDMwQzY0LDUwLjU2OCw1MC41NjgsNjQsMzQsNjR6IiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojM0E1ODlCOyIvPjwvc3ZnPg=="/>
                </div>
                <div className="facebookLabel">LOG IN WITH FACEBOOK</div>
            </FacebookLogin>
            <GoogleLogin
              onSuccess={this.googleSuccess}
              onError={this.googleError}
              className="socialLoginButton google"
              logo_alignment="center"
              width="300"/>
            <Dialog
              open={this.state.passwordDialogOpen}
              onClose={this.closePasswordReminder}
              aria-labelledby="form-dialog-title">
              <DialogTitle id="form-dialog-title">Password Reset</DialogTitle>
              <DialogContent>
                <DialogContentText id="passwordEmailErrorMessage">
                  {this.state.passwordEmailErrorMessage}
                </DialogContentText>
                <DialogContentText>
                  Enter your email address and we'll send you a password reset link.
                </DialogContentText>
                <TextField
                  autoFocus
                  onChange={this.handleInputChange('passwordEmail')}
                  margin="dense"
                  label="Email Address"
                  className="forgotEmail"
                  variant="standard"
                  helperText={this.state.passwordErrorMessage}
                  error={this.state.passwordError}
                  type="email"
                  fullWidth/>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closePasswordReminder} color="primary">
                  Cancel
                </Button>
                <Button onClick={this.forgotPassword.bind(this)} color="primary">
                  Reset My Password
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
        <div className="footer">
          <div>
            <span><a href={KEY_TERMS_AND_CONDITIONS}>Terms of Service</a></span>
            <span><a href={KEY_PRIVACY_POLICY}>Privacy Policy</a></span>
          </div>
          <div className="copyright">Copyright &copy; 2024 CalendarBudget Inc. All Rights Reserved.</div>
        </div>     
      </div>
    )
  }
}

export default withCookies(App)
